module.exports = __webpack_public_path__ + "media/webmil_mobile.2ddb3a36.mp4";